import { Injectable } from '@angular/core';
import { Endpoint, SignalRMethod } from '@app/core/constants/enums';
import { AppConfigService } from '@app/core/services/app-config.service';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  public hubConnection!: HubConnection;
  public signalrConnection = new BehaviorSubject(false);
  constructor(
    private readonly appConfigService: AppConfigService
  ) {
    this.hubConnection = this.getConnection();
  }
  initializeConnection(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const url = this.appConfigService.getEndpoint(Endpoint.RealTimeMessaging);
      this.hubConnection = new HubConnectionBuilder()
        .withUrl(url, {
        })
        .withAutomaticReconnect()
        .build();

      this.hubConnection.start()
        .then(() => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  setConnection(hubConnection: HubConnection): void {
    this.hubConnection = hubConnection;
  }
  getConnection(): HubConnection {
    return this.hubConnection;
  }
  async addToGroup(groupName: string): Promise<void> {
    await this.hubConnection?.invoke(SignalRMethod.AddToGroup, groupName);
  }
  async removeFromGroup(groupName: string): Promise<void> {
    return this.hubConnection?.invoke(SignalRMethod.RemoveFromGroup, groupName);
  }
  async sendMessageToGroup(groupName: string, message: string, model?: any): Promise<void> {
    console.log('group name:', groupName);
    await this.hubConnection?.invoke(SignalRMethod.SendMessageToGroup, groupName, message, model);
  }

  addMessageReceivedListener(callback: (groupName: string, message: string, model?: any) => void): void {
    this.hubConnection?.on(SignalRMethod.ReceiveMessage, callback);
  }
  removeMessageReceivedListener(callback: (groupName: string, message: string, model?: any) => void): void {
    this.hubConnection?.off(SignalRMethod.ReceiveMessage, callback);
  }
}
